<template>
  <div class="section header home">
    <b-container align-v="center">
      <b-row
        align-v="center"
        class="vcenter"
        data-aos="zoom-out-down"
        data-aos-anchor=".home"
        data-aos-anchor-placement="top-center"
      >
        <b-col cols="12" md="7" class="text-md-left zi-1"
          ><h1 class="fsize1 font-weight-bold my-0">
            Buy and Sell Cryptos via
            <span class="text-orange">Over-The-Counter.</span>
          </h1>
          <h3 class="fsize3 font-weight-thin mt-4 mb-4">
            Fast. Easy. Convenient.
          </h3>
          <b-button
            variant="outline-success"
            size="lg"
            class="mt-1"
            @click="moveTo('about')"
            >Learn More</b-button
          >
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="text-md-left zi-0"
          data-aos="zoom-out-up"
          data-aos-delay="500"
        >
          <img src="@/assets/section-img-1.svg" class="illustration" alt="" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    moveTo: {
      type: Function
    }
  }
}
</script>

<style lang="scss" scoped></style>
